/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    exchanges: {
        menu: {
            index: 'Exchanges',
            create: 'New',
            list: 'Exchanges'
        },
        table_titles: {
            id: 'ID',
            name: 'Name',
            exchange_fee: 'Exchange fee',
            setting: 'Edit / Delete',
        },
        edit: 'Edit an exchange'
    }
}
